
import { Box, Link, SegmentedControl } from '@primer/react';
import { LinkExternalIcon } from '@primer/octicons-react';
import { useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IMenuModel } from '../../models/response/account/user-info';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
import { ILayoutContext, LayoutContext } from '../Layout';
import Button from '../../components/ui/button';
import { useLocation } from 'react-router-dom';

const IsHaveChidrenMatchPath = (rootMenu: IMenuModel, path: string): boolean => {
    if (rootMenu.items && rootMenu.items.length > 0) {
        const menu = rootMenu.items.find(x => x.path === path || IsHaveChidrenMatchPath(x, path));
        return menu !== undefined;
    } else {
        return rootMenu.path === path;
    }
};

const MenuGroup = () => {
    const { user_info } = useSelector((x: RootState) => x.auth)
    const { menu_group_id, language } = useSelector((x: RootState) => x.common)
    const dispatch = useDispatch();
    const location = useLocation();
    const { setHideSubNav } = useContext<ILayoutContext>(LayoutContext);
    const menus = useMemo(() => {
        return user_info?.menus ?? []
    }, [user_info])
    const findMenu = (menu: IMenuModel, pathName: string): IMenuModel | undefined => {
        if (menu.path === pathName) return menu;
        if (menu.items && menu.items.length > 0) {
            for (const subMenu of menu.items) {
                const result = findMenu(subMenu, pathName);
                if (result) return result;
            }
        }
        return undefined;
    };
    const selectedMenu = useMemo(() => {
        const pathName = location.pathname.startsWith('/') ? location.pathname.slice(1) : location.pathname;

        if (menus.length > 0) {
            for (const subMenu of menus) {
                const result = findMenu(subMenu, pathName);
                if (result) return result;
            }
        }

        return undefined;
    }, [menus, location.pathname])

    useEffect(() => {
        const pathname = location.pathname.replace(/^\/|\/$/g, '');
        if (!pathname || pathname === 'home' || pathname === 'dashboard' || pathname === 'bus/dashboard') {
            return;
        }
        let result = 0;
        user_info?.menus.forEach(rootMenu => {
            if (result === 0) {
                const check = IsHaveChidrenMatchPath(rootMenu, pathname);
                if (check) {
                    result = rootMenu.id;
                }
            }
        });
        if (result > 0 && result !== menu_group_id) {
            dispatch(actions.common.changeMenuGroup(result));
        }
    }, [location.pathname, user_info]);

    const handleSelectMenu = (menu: IMenuModel) => {
        if (setHideSubNav) setHideSubNav(false);
        if (menu.id !== menu_group_id) {
            dispatch(actions.common.changeMenuGroup(menu.id));
        }
    };

    return (
        <>
            <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}>
                <Box sx={{ width: "150px" }}>&nbsp;</Box>
                <Box sx={{ pt: 1, pb: 1, display: "flex", flex: 1, justifyContent: "center", width: "100%" }}>
                    {user_info &&
                        <SegmentedControl onChange={(e) => {
                            if (user_info.menus[e]) {
                                handleSelectMenu(user_info.menus[e]);
                            }
                        }}
                        >
                            {user_info.menus.map((menu, index) => {
                                const Icon = () => {
                                    return <i className={`${menu.icon}`}></i>
                                }
                                return (
                                    <SegmentedControl.Button
                                        key={menu.id}
                                        selected={menu.id === menu_group_id}
                                        leadingIcon={Icon}
                                        onClick={(e: any) => {
                                            e?.preventDefault?.();
                                            e?.stopPropagation?.();
                                        }}
                                        sx={{
                                            color: "#182C62",
                                            cursor: "pointer"
                                        }}

                                    >
                                        {language === "en" ? menu.name_en : menu.name}
                                    </SegmentedControl.Button>
                                )
                            })}
                        </SegmentedControl>
                    }

                </Box>
                <Box sx={{ width: "150px", display: "flex", flexDirection: "row-reverse" }}>
                    {selectedMenu?.user_guide_link ? (
                        <Link href={selectedMenu.user_guide_link} target='_blank'>
                            <Button text='Hướng dẫn sử dụng'
                                variant='invisible'
                                leadingVisual={LinkExternalIcon}
                            />
                        </Link>
                    ) : (
                        <Button text='Hướng dẫn sử dụng'
                            variant='invisible'
                            disabled
                            leadingVisual={LinkExternalIcon}
                        />
                    )}
                </Box>
            </Box>

        </>

    );
};

export default MenuGroup;